import urljoin from 'url-join';
import log from 'loglevel';

import fetch2, { METHOD } from 'Util/fetch';

/**
 * NOTE: Function for Navigate to TungKai with token and redirect path management
 * @param {Object} params
 * @param {string} [params.redirectPath] - Path to redirect to (Optional)
 * @param {Object} params.config - object that contains userApi and tungKai config
 * @param {Function} params.openInApp - function to open URL in App
 */
export const navigateToTungKai = async ({ redirectPath, config, openInApp }) => {
  const { userApi, tungKai: tungKaiConfig } = config;
  const tungKaiLoginUrl = tungKaiConfig?.loginUrl;
  const baseRedirectPath = redirectPath || '/';

  if (!tungKaiLoginUrl || !openInApp) {
    log.error('[NavigateToTungKai]: Missing dependencies', {
      tungKaiLoginUrl,
      hasOpenInApp: !!openInApp,
    });
    return;
  }

  try {
    const token = await fetch2(urljoin(userApi, '/me/session'), {}, METHOD.POST, null, {
      isRedirect: false,
      includeCredentials: true,
    });

    if (!token) throw new Error('[NavigateToTungKai]: Failed to fetch token');

    let loginUrlWithToken = tungKaiLoginUrl.replace('{token}', token);

    const urlObj = new URL(loginUrlWithToken);
    urlObj.searchParams.set('redirectPath', baseRedirectPath);

    return openInApp(urlObj.toString());
  } catch (error) {
    log.error('[NavigateToTungKai]: Error:', error);
    throw error;
  }
};
